import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>Snaply</h3>
            <p>Digital receipts, simplified.</p>
          </div>

          <div className="footer-links">
            <a href="mailto:snaply8@gmail.com">
              snaply8@gmail.com
            </a>
            <a href="#privacy">
              Privacy
            </a>
            <a href="#terms">
              Terms
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Snaply. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
